import { PencilIcon } from './PencilIcon';

/**
 * author: Google
 * id BB27CE6C-769A-4C0C-A53C-F1B10B9C4423
 * name pencil
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/pencil.svg
 * tags
 * - Drawing / Art 
 * - Edit / Modify 
 */
export const EditIcon = PencilIcon;
export default EditIcon